import { Component } from '@angular/core';
import { ToastService } from '../../../../services/toast.service';
import { Producao } from '../../../../types/producao.type';
import { ProducaoindustrialService } from '../../../../services/producaoindustrial.service';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
  selector: 'app-producaos',
  templateUrl: './producaos.component.html',
  styleUrl: './producaos.component.css'
})
export class ProducaosComponent {

  producaos: Producao[] = [];
  loading: boolean = true;
  totalRecords: number = 0;
  rows: number = 20;
  filtro: string = '';

  private ultimoEvento: TableLazyLoadEvent = { first: 0, rows: this.rows };
  private debounceFiltro: any;

  constructor(private producaoIndustrialService: ProducaoindustrialService, private toastService: ToastService) { }

  carregar(event: TableLazyLoadEvent) {
    this.ultimoEvento = event;
    this.loading = true;

    const first = event.first ?? 0;
    const rows = event.rows ?? this.rows;
    const page = first / rows;

    this.producaoIndustrialService.getProducaos(page, rows, this.filtro || undefined).subscribe({
      next: (data) => {
        this.producaos = this.ordenarLocalmente(data.content, event.sortField, event.sortOrder);
        this.totalRecords = data.totalElements;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar: " + error.error);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  buscar() {
    clearTimeout(this.debounceFiltro);
    this.debounceFiltro = setTimeout(() => {
      this.carregar({ ...this.ultimoEvento, first: 0 });
    }, 400);
  }

  getProducaos() {
    this.carregar(this.ultimoEvento);
  }

  // A ordenação é fixa no backend (empresa, depois data de produção); aqui só
  // reordenamos os registros já carregados na página atual, sem enviar sort à API.
  private ordenarLocalmente(lista: Producao[], sortField: string | string[] | null | undefined, sortOrder: number | null | undefined): Producao[] {
    if (!sortField || typeof sortField !== 'string') {
      return lista;
    }

    const ordem = sortOrder ?? 1;
    const campo = sortField as keyof Producao;

    return [...lista].sort((a, b) => {
      const valorA = a[campo];
      const valorB = b[campo];

      if (valorA == null && valorB == null) return 0;
      if (valorA == null) return -1 * ordem;
      if (valorB == null) return 1 * ordem;

      if (valorA < valorB) return -1 * ordem;
      if (valorA > valorB) return 1 * ordem;
      return 0;
    });
  }
}
